import Swiper from 'swiper/dist/js/swiper.min';
import Api from '../../../base/script/api';
import PopupProjectsObject from './popup-projects-object.pug';
import InputCountry from '../../../core/input/country/input-country';

const changeSlidesClasses = (list, index, className) => {
  if (list.length) {
    const activeSlide = list.find(el => el.classList.contains(className));
    if (activeSlide) {
      activeSlide.classList.remove(className);
      list[index].classList.add(className);
    }
  }
};

export default {
  props: {
    content: {
      type: Object,
      // default: () => {},
    },
  },
  template: PopupProjectsObject(),
  delimiters: ['${', '}}'],
  components: {
    InputCountry,
  },
  data() {
    return {
      formComplete: false,
      showError: false,
      isSubmited: false,
      nameValidation: false,
      formData: {
        type: 'call',
        phone: null,
        name: null,
        agree: false,
        agreeAds: false,
      },
    };
  },
  methods: {
    completeForm(phone) {
      this.formComplete = true;
      this.formData.phone = phone;
    },
    acceptForm(value) {
      this.formComplete = false;
      if (value.length === 0) this.showError = false;
    },
    closePopup() {
      this.isSubmited = false;
      this.showError = false;
      this.formComplete = false;
      this.formData.name = null;
      this.formData.phone = null;
      this.$emit('on-close-handler');
    },
    openPopup() {
      if (this.$refs.form) {
        const elements = [].slice.call(this.$refs.form);
        if (elements.length) {
          this.isSubmited = true;
          this.showError = !this.formComplete;
          if (this.isNameValid && (!this.$refs.agreeInput || this.isAgree) && this.formComplete) {
            Api.post(this.$refs.form.action, this.formData).then((response) => {
              if (response.data) {
                this.$emit('on-close-handler');
              }
            });
          }
        }
      }
    },
  },
  computed: {
    isAgree() {
      return this.formData.agree;
    },
    isAgreeAds() {
      return this.formData.agreeAds;
    },
    isNameValid() {
      return !this.nameValidation || !this.$refs.nameInput || (this.formData.name && this.formData.name.length > 0);
    },
  },
  mounted() {
    window.bodyLock.disableBodyScroll(this.$el.querySelector('.popup-projects-object__content-box'));

    const swiperContainer = this.$el.querySelector('.popup-projects-object__slider-container');
    const swiperThumbContainer = this.$el.querySelector('.popup-projects-object__slider-thumb-container');
    const thumbSlides = [].slice.call(this.$el.querySelectorAll('.popup-projects-object__thumb-slide'));
    if (swiperContainer && swiperThumbContainer) {
      // eslint-disable-next-line no-unused-vars
      let activeSlide = 0;
      setTimeout(() => {
        const thumbSliderInstance = new Swiper(swiperThumbContainer, {
          slideToClickedSlide: true,
          slidesPerView: 'auto',
        });

        const sw = new Swiper(swiperContainer, {
          navigation: {
            nextEl: this.$el.querySelector('.popup-projects-object__slider-button--next'),
            prevEl: this.$el.querySelector('.popup-projects-object__slider-button--prev'),
          },
          pagination: {
            el: this.$el.querySelector('.popup-projects-object__pagination'),
            type: 'fraction',
          },
          thumbs: {
            slider: thumbSliderInstance,
          },
          on: {
            slideChange() {
              activeSlide = sw.activeIndex;
              changeSlidesClasses(thumbSlides, activeSlide, 'popup-projects-object__thumb-slide--active');
            },
          },
        });

        if (thumbSlides.length) {
          thumbSlides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
              activeSlide = index;
              changeSlidesClasses(thumbSlides, activeSlide, 'popup-projects-object__thumb-slide--active');
              if (sw) {
                sw.slideTo(activeSlide);
              }
            });
          });
        }
      }, 0);
    }
  },
};



// WEBPACK FOOTER //
// ./new-blocks/popup/projects-object/popup-projects-object.js